export function onlyAllowed(current, allowed) {
  function setContainsOnlyAllowed(current, allowed) {
    for (const item of current) if (!allowed.has(item)) return false;
    return true;
  }

  if (current.length === 0) {
    throw 'Implicit values';
  }
  return setContainsOnlyAllowed(new Set(current), new Set(allowed));
}
